import React, { FunctionComponent } from 'react'
import { Circle, Rect, Svg } from 'react-native-svg'

import { Tooltip } from '../../atoms/tooltip/Tooltip'
import { colors } from '../../styles/colors'
import { tID } from '../../utils/utils'

export const SingleSessionCoachingIcon: FunctionComponent<SingleSessionCoachingIconProps> = ({
  showTooltip = true,
  tooltip = 'Guided Self-Care',
  width = 44,
  height = 44,
}) => {
  const icon = (
    <Svg width={width} height={height} viewBox={'0 0 52 52'} testID={tID('SingleSessionCoachingIcon')}>
      <Rect width={52} height={52} rx={4} fill={colors.purple1} />
      <Circle cx={26} cy={26} r={6} fill={colors.purple4} />
    </Svg>
  )

  return showTooltip ? (
    <Tooltip content={tooltip} placement='bottom' hoverEnabled={true}>
      {icon}
    </Tooltip>
  ) : (
    <>{icon}</>
  )
}

export type SingleSessionCoachingIconProps = {
  showTooltip?: boolean
  tooltip?: string
  width?: number
  height?: number
}
